/**
 * Botão "Compartilhar tela" da barra. Só existe onde o navegador captura a tela (no celular não). Ligado, fica ciano
 * e vira "Parar de compartilhar a tela" (o ícone também troca: a cor nunca é o único sinal). O clique entrega à
 * captura a janela em que aconteceu, que na sala flutuante não é a da guia (ver `screenShare`).
 */
import { MonitorOff, MonitorUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { FOCUS_RING, SIZE, TONE } from './controlStyles';
import { useScreenShare } from './ScreenShareProvider';

/** Parte visual, sem hooks. */
export function ScreenShareButtonView({ sharing, pending = false, variant, onClick }) {
    const Icon = sharing ? MonitorOff : MonitorUp;
    const label = sharing ? 'Parar de compartilhar a tela' : 'Compartilhar tela';
    return (
        <button
            type="button"
            aria-label={label}
            title={label}
            disabled={pending}
            onClick={onClick}
            data-screen-share-button=""
            data-sharing={sharing ? 'true' : 'false'}
            className={cn(
                'flex items-center justify-center rounded-full transition-colors disabled:opacity-60',
                sharing ? TONE.active : cn(TONE.on, 'hover:bg-white/20'),
                SIZE[variant].btn,
                FOCUS_RING,
            )}
        >
            <Icon className={SIZE[variant].icon} aria-hidden="true" />
        </button>
    );
}

/** @param {{ variant: keyof typeof SIZE }} props */
export function ScreenShareButton({ variant }) {
    const { supported, sharing, pending, toggle } = useScreenShare();
    if (!supported) return null;
    return (
        <ScreenShareButtonView
            sharing={sharing}
            pending={pending}
            variant={variant}
            onClick={(event) => toggle(event.currentTarget.ownerDocument?.defaultView ?? undefined)}
        />
    );
}
